const link_list = {
    routePath: 'teammembers',
    actionName: 'count',
    iconClass: 'fa-solid fa-calendar-check',
    title: 'Recent Active Invites',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default {link_list }